import { DashboardRounded } from "@mui/icons-material";
import NoItemsDisplay from "../Custom/NoItemsDisplay";
import "./styles/Dash.css";
import WelcomeCard from "./Cards/WelcomeCard";
import WeeklyCard from "./Cards/WeeklyCard";
import ExamProgressCard from "./Cards/ExamProgressCard";
import BoostScoresCard from "./Cards/BoostScoresCard";
import FlashProgressCard from "./Cards/FlashProgressCard";
import Accomplishments from "./Cards/Accomplishments";
import ExamMetrics from "./Cards/ExamMetrics";
import FlashMetrics from "./Cards/FlashMetrics";
import { Skeleton } from "@mui/material";

const DashLoader = () => {
  return (
    <div className="dashboard-container loader">
      {/* Set a fixed height for the top one since it has no flex neighbor */}
      <Skeleton className="dash-card"/>

      <div className="dash-row">
        <div className="dash-child left-items custom-spacing">
          <div className="side-by-side gap-3">
            <Skeleton className="dash-card" />
            <Skeleton className="dash-card" />
          </div>
          <Skeleton className="dash-card" />
        </div>
        <div className="dash-child right-items custom-spacing">
          <Skeleton className="dash-card" />
          <Skeleton className="dash-card" />
        </div>
      </div>

      <div className="dash-row">
        <Skeleton className="dash-card" />
        <Skeleton className="dash-card" />
      </div>
    </div>
  );
};
const DashContent = ({ dash, loading }) => {
  if (loading) return <DashLoader />;

  if (!dash)
    return (
      <NoItemsDisplay
        children={
          <DashboardRounded
            color="iconGray"
            className="no-items-icon"
            sx={{ transform: "rotate(90deg)" }}
          />
        }
        textItems={["There are currently no dashboard metrics available."]}
      />
    );
  const {
    user_name,
    weekly_activity,
    exam_in_progress,
    exam_metrics,
    flashcards_in_progress,
    boost_scores,
    accomplishments,
    flashcard_metrics,
  } = dash;
  return (
    <div className="dashboard-container">
      <WelcomeCard name={user_name} />
      <div className="dash-row">
        <div className="dash-child left-items custom-spacing">
          <div className="side-by-side gap-3">
            <WeeklyCard weeklyActivity={weekly_activity} />
            <ExamProgressCard progressExam={exam_in_progress} />
          </div>
          <Accomplishments awards={accomplishments} />
        </div>
        <div className="dash-child right-items custom-spacing">
          <BoostScoresCard scores={boost_scores} />
          <FlashProgressCard deck={flashcards_in_progress} />
        </div>
      </div>
      <div className="dash-row">
        <ExamMetrics metrics={exam_metrics} />
        <FlashMetrics metrics={flashcard_metrics} />
      </div>
    </div>
  );
};

export default DashContent;
